import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})
export class SeoService {
    constructor(private meta: Meta, private title: Title) {}

    updateMetaTags(config: {
        title: string;
        description: string;
        keywords: string;
        author?: string;
        url?: string;
        image?: string,
        siteName?: string;
    }): void {
        let author: string = 'SolarCentral in collaboration with VisualAge Technologies, South Africa';
        let image: string = 'https://www.solarcentral.co.za/images/logo.png';
        let url: string = 'https://www.solarcentral.co.za/';
        let siteName: string = 'Solar Central';

        // Update page title
        this.title.setTitle(config.title);

        // Update SEO meta tags
        this.meta.updateTag({ name: 'description', content: config.description });
        this.meta.updateTag({ name: 'keywords', content: config.keywords });
        this.meta.updateTag({ name: 'author', content: config.author || author });
        this.meta.updateTag({ name: 'robots', content: 'index, follow' });

        // Update Open Graph meta tags
        this.meta.updateTag({ property: 'og:title', content: config.title });
        this.meta.updateTag({ property: 'og:description', content: config.description });
        this.meta.updateTag({ property: 'og:type', content: 'website' });
        this.meta.updateTag({ property: 'og:site_name', content: config.siteName || siteName });
        this.meta.updateTag({ property: 'og:url', content: config.url || url });
        this.meta.updateTag({ property: 'og:image', content: config.image || image });

        // Update Twitter Card meta tags
        this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
        this.meta.updateTag({ name: 'twitter:title', content: config.title });
        this.meta.updateTag({ name: 'twitter:description', content: config.description });
        this.meta.updateTag({ name: 'twitter:image', content: config.image || image });
    }
}